[
  {
    "invalid": "“",
    "valid": "\""
  },
  {
    "invalid": "”",
    "valid": "\""
  },
  {
    "invalid": "–",
    "valid": "-"
  },
  {
    "invalid": "—",
    "valid": "-"
  },
  {
    "invalid": "’",
    "valid": "'"
  },
  {
    "invalid": "‘",
    "valid": "'"
  },
  {
    "invalid": " ",
    "valid": " "
  }
]
